import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1caf04f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container rounded p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Reset You Password")
], -1))
const _hoisted_3 = { class: "fv-row mb-10 position-relative" }
const _hoisted_4 = { class: "d-flex flex-stack mb-2" }
const _hoisted_5 = { class: "form-label fw-bolder text-dark fs-6 mb-0" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "fv-row mb-10 position-relative" }
const _hoisted_9 = { class: "form-label fs-6 fw-bolder text-dark" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_14 = { class: "indicator-label" }
const _hoisted_15 = { class: "indicator-progress" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "",
      onSubmit: _ctx.onSubmitReset,
      id: "kt_login_signin_form",
      "validation-schema": _ctx.loginSchema,
      ref: "form"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.translate('password')), 1)
          ]),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: _ctx.passwordVisible ? 'text' : 'password',
            name: "password",
            autocomplete: "off"
          }, null, 8, ["type"]),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.passwordVisible = !_ctx.passwordVisible)),
            class: "toggle-password-icon"
          }, _toDisplayString(_ctx.passwordVisible ? 'Hide' : 'Show'), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.translate('confirmPassword')), 1),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: _ctx.conrifmPasswordVisible ? 'text' : 'password',
            name: "confirmPassword",
            autocomplete: "new-password"
          }, null, 8, ["type"]),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.conrifmPasswordVisible = !_ctx.conrifmPasswordVisible)),
            class: "toggle-password-icon"
          }, _toDisplayString(_ctx.conrifmPasswordVisible ? 'Hide' : 'Show'), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_ErrorMessage, { name: "confirmPassword" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate('continue')), 1),
            _createElementVNode("span", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
              _hoisted_16
            ])
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}